module.exports = __webpack_public_path__ + "img/f19.cda6cd0a.jpg";